let showHandler = null;
const pending = [];

export function setConfirmHandler(handler) {
  showHandler = handler;
  if (handler) {
    while (pending.length) {
      handler(pending.shift());
    }
  }
}

/**
 * In-app confirm dialog. Replaces window.confirm so the UI does not show
 * "localhost says".
 *
 * @param {string|object} messageOrOpts
 * @returns {Promise<boolean>}
 */
export function appConfirmMessage(messageOrOpts, extra = {}) {
  const opts =
    messageOrOpts && typeof messageOrOpts === 'object' && !Array.isArray(messageOrOpts)
      ? { ...messageOrOpts, ...extra }
      : { message: messageOrOpts, ...extra };

  const message = String(opts.message || 'Are you sure?');
  const danger =
    opts.danger ??
    /delete|remove|permanent|cannot be undone|last chance/i.test(message);

  const request = {
    title: opts.title || 'Please confirm',
    message,
    confirmLabel: opts.confirmLabel || (danger ? 'Delete' : 'Confirm'),
    cancelLabel: opts.cancelLabel || 'Cancel',
    danger,
  };

  return new Promise((resolve) => {
    const payload = { ...request, resolve };
    if (showHandler) showHandler(payload);
    else pending.push(payload);
  });
}
